import { render } from "./Aiet.vue?vue&type=template&id=1aed3d8b"
import script from "./Aiet.vue?vue&type=script&lang=js"
export * from "./Aiet.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__